import dayjs from "dayjs";

export function formatDatePipe(date: string) {
    const m = dayjs(date);
    if (m.isValid()) {
        return m.format("DD/MM/YYYY");
    }
    return "";
}

export function formatDateTimePipe(date: string) {
    const m = dayjs(date);
    if (m.isValid()) {
        return m.format("DD/MM/YYYY-HH:mm:ss");
    }
    return "";
}